export default __webpack_public_path__ + "assets/twitter-icon-be99687e397debab5e2537b96982d03e.svg";